import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { serviceOfferingsBackend } from './service-offerings.backend';
import { serviceOfferingsReducer } from './service-offerings.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('serviceOfferings', serviceOfferingsReducer),
    BackendModule.forFeature('serviceOfferings', serviceOfferingsBackend),
  ],
})
export class DatastoreServiceOfferingsModule {}
